import { setEvents } from "../events";
import { setProductFlag, buildProductFlag } from "./productFlags";

export default function setWaysToStyleTracking(numberOfLooks) {
  setProductFlag(buildProductFlag({ key: "bca", shown: numberOfLooks > 0 }));
  setEvents({
    events: ["event341", `event354=${numberOfLooks}`],
    trackingName: "pageLoad",
  });
}
